import React from 'react'
import type { HTMLElementProps, ShopifySection } from '~/types'
import { cn } from '~/utils'

type Props = React.HTMLProps<HTMLElement> & {
	title?: React.ReactNode
	containerCns?: string
	section?: ShopifySection
	backgroundColor?: string
}

export const Title: React.FC<React.HTMLProps<HTMLHeadingElement>> = ({ className, children, ...props }) => (
	<h2 className={cn('mb-16 text-center', className)} {...props}>
		{children}
	</h2>
)

export const Section: React.FC<Props> = ({
	className,
	containerCns,
	title,
	children,
	section,
	backgroundColor,
	...props
}) => (
	<div
		className={cn(containerCns)}
		data-section-id={section?.id}
		data-section-type={section?.name}
		style={{ backgroundColor }}
	>
		<section className={cn('max-w-pagewidth-xl mx-auto px-8 pb-40 pt-16', className)} {...props}>
			<>{title && <Title>{title}</Title>}</>
			<>{children}</>
		</section>
	</div>
)

export const List: React.FC<HTMLElementProps<'ul'>> = ({ className, children, ...props }) => (
	<ul className={cn('list grid grid-cols-1 gap-10 text-white sm:grid-cols-2 lg:grid-cols-3', className)} {...props}>
		{children}
	</ul>
)
